module.exports = __webpack_public_path__ + "img/jz-pic2.5ed342f3.png";